module.exports = __webpack_public_path__ + "static/media/default-white.c785e1af.svg";